<template>
  <div class="event-checkin-modal-component p-2">
    <div class="d-flex align-items-center justify-content-between">
      <h3>Fazer check-in</h3>
      <button
        class="btn btn-circle btn-20 bg-neutral-048"
        @click="$emit('close')"
      >
        <i class="fa-regular fa-xmark fs-14" />
      </button>
    </div>

    <template v-if="!data.code">
      <h4 class="my-3 pt-6 text-center">Escanear QR code</h4>
      <div class="d-flex justify-content-center mb-6">
        <bp-qr-code-scanner id="checkin-qr-code-scanner" @ondecode="decode" />
      </div>
      <div v-if="error_message" class="text-center text-negative-500">
        {{ error_message }}
      </div>
    </template>

    <template v-else>
      <h4 class="text-neutral-300 mb-6 pb-3 pr-lg-9 mr-lg-7">
        Antes de fazer check-in, confira se os dados abaixo estão corretos
      </h4>

      <div class="border rounded border-neutral-300 p-5">
        <div class="px-3">
          <div class="d-flex align-items-center justify-content-between mb-5">
            <span>Nome do Comprador:</span>
            <span> {{ data.shopper_name }}</span>
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <span>Código do pedido:</span>
            <span>BP{{ data.order_id }}</span>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-6 pt-3">
        <button
          class="btn btn-secondary btn-new-secondary px-6"
          @click="data = {}"
        >
          Voltar
        </button>
        <button
          class="btn btn-primary btn-primary px-6 ml-3"
          @click="confirmCheckIn"
        >
          Confirmar check-in
        </button>
      </div>
    </template>
  </div>
</template>
<script>
import { BpQrCodeScanner } from "@/components/designSystem";

export default {
  components: { BpQrCodeScanner },
  props: {
    participant: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      step: 1,
      data: { ...this.participant },
      error_message: null
    };
  },
  methods: {
    decode(result) {
      this.getCheckInDetails(result);
    },
    getCheckInDetails(ticket) {
      this.$store
        .dispatch("events/getCheckIn", ticket)
        .then(result => {
          this.error_message = null;
          if (result.checkin_at) {
            this.$emit("repeated-code");
          } else {
            this.data = result;
            this.step = 2;
          }
        })
        .catch(() => {
          this.error_message =
            "Código não encontrado, verifique e tente novamente.";
        });
    },
    confirmCheckIn() {
      let params = {
        code: this.data?.code,
        checkin_at: new Date().toISOString()
      };
      this.$store
        .dispatch("events/checkIn", params)
        .then(() => this.$emit("success"))
        .catch(() => this.$message.error("Ocorreu um erro ao fazer check-in."));
    }
  }
};
</script>
